import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge, validators } from "tailwind-merge"

// Teach tailwind-merge the custom scales in tokens.css. Without this it reads
// `text-h1` as a text colour and drops it when merged with `text-foreground`,
// and it cannot tell that `h-control-sm` and `h-control-md` conflict.
const twMerge = extendTailwindMerge<
  "focus-ring" | "focus-ring-within" | "animation-duration"
>({
  extend: {
    theme: {
      text: [
        "display",
        "h1",
        "h2",
        "h3",
        "kpi",
        "body",
        "body-sm",
        "ui",
        "meta",
        "eyebrow",
        "label",
        "preamble",
        "button",
      ],
      shadow: ["raised", "overlay", "modal"],
      radius: ["hover"],
      ease: ["standard", "brand"],
      spacing: [
        "control-xs",
        "control-sm",
        "control-md",
        "control-lg",
        "row-sm",
        "row-md",
        "row-lg",
      ],
    },
    classGroups: {
      duration: [{ duration: ["fast", "base", "brand"] }],
      // Inset replaces the outside ring, so the two conflict.
      "focus-ring": ["focus-ring", "focus-ring-inset"],
      "focus-ring-within": ["focus-ring-within"],
      // tw-animate-css utility; `loop` is the looping-indicator token.
      "animation-duration": [
        {
          "animation-duration": [
            "loop",
            "initial",
            validators.isNumber,
            validators.isArbitraryValue,
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
